/**
 * Hogarmola: comportamiento propio de la marca sobre Horizon.
 *
 * 1. Textos que dependen de la variante (subtítulo y línea de ahorro de la ficha):
 *    los elementos con [data-hm-sync] e id se copian del HTML nuevo que Horizon
 *    descarga al cambiar de variante (evento estándar shopify:product:select).
 * 2. Botón «Configurar cookies» del pie: abre las preferencias del banner de cookies
 *    de Shopify si está activo; si no, sigue el enlace a la política de cookies.
 * 3. Botón «Añadir» del complemento del carrito lateral (snippet cart-upsell):
 *    usa Shopify.actions.updateCart para que el carrito se refresque solo.
 */
(function () {
  if (window.hogarmolaReady) return;
  window.hogarmolaReady = true;

  // 1. Textos que dependen de la variante
  document.addEventListener('shopify:product:select', function (event) {
    var promise = event && event.promise;
    if (!promise || typeof promise.then !== 'function') return;

    promise
      .then(function (result) {
        var html = result && result.detail && result.detail.html;
        if (!html || typeof html.querySelectorAll !== 'function') return;

        html.querySelectorAll('[data-hm-sync][id]').forEach(function (fresh) {
          var current = document.getElementById(fresh.id);
          if (current) current.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
  });

  // 2. Configurar cookies
  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element ? event.target.closest('[data-hm-cookie-preferences]') : null;
    if (!trigger) return;

    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
  });

  // 3. Complemento del carrito lateral
  document.addEventListener('submit', function (event) {
    var form = event.target instanceof Element ? event.target.closest('form[data-cart-upsell]') : null;
    if (!form) return;

    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || typeof actions.updateCart !== 'function') return;

    var input = form.querySelector('input[name="id"]');
    if (!input) return;

    event.preventDefault();
    var button = form.querySelector('button');
    if (button) button.disabled = true;

    actions.updateCart({ lines: [{ merchandiseId: String(input.value), quantity: 1 }] }).catch(function () {
      form.submit();
    });
  });
})();
